import React, { Fragment } from "react";
import { offeringConfig } from "../offering_config";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { Spacer } from "../spacer";
import { Text } from "../text";
import { TextLink } from "../text_link";
import { useUrbanplaceAnalytics } from "./urbanplace_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./urbanplace_partner_config";
import { lazyWithRetry } from "../../core/lazy_with_retry";

const Theme = lazyWithRetry(() => import("./urbanplace_theme"));

const faqs = [
  {
    question: "Can I share my pass with other people?",
    answer: "The Day Pass is for personal use only and is not transferable.",
  },

  {
    question: "Can I use the meeting rooms?",
    answer: (
      <Text>
        Yes, the meeting rooms are charged at an hourly rate.{" "}
        <TextLink
          href={`offerings/${offeringConfig.Urbanplace.slugConfig.meetingRooms}`}
        >
          You can book a meeting room here.
        </TextLink>
      </Text>
    ),
  },

  {
    question: "Can I use the printer?",
    answer:
      "Yes, please get in touch with the community manager and we will assist you.",
  },

  {
    question: "Can I meet with clients or bring a guest using my day pass?",
    answer:
      "Your day pass is for personal use only and doesn’t cover guests. You may purchase additional day passes for each of your guests.",
  },

  {
    question: "Where can I keep and heat my lunch?",
    answer:
      "The kitchen, refrigerator and microwave is available for your use.",
  },

  {
    question: "Do you offer coffee or tea?",
    answer: "Yes, coffee and tea are complimentary.",
  },

  {
    question: "Can I cancel my day pass purchase?",
    answer:
      "Yes, the Day Pass can be cancelled and fully refunded 48 hours before the start of the booking.",
  },
  {
    question: "Can I change the date of my day pass booking?",
    answer:
      "Yes. Please either call us or reply to the confirmation email and we will take care of it.",
  },
];

export function OfferingUrbanplaceDayPass() {
  useUrbanplaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: (
            <Fragment>
              <Text>
                Not everyone needs an office, but everyone needs a place to
                work. Our beautiful renovated open space is the perfect place
                for those days where you just need to get out of the house and
                work on a project.
              </Text>
              <Spacer size={8} />
              <Text>
                Find a seat in the common area and enjoy member benefits for the
                day.
              </Text>
            </Fragment>
          ),
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
